import type { FandomTaxonomyCategoryKey } from "./../types";

import {
  IAB_BSR_DEFAULT_LOW_RISK_CATEGORY,
  IAB_ENTERTAINMENT_CONTENT_CATEGORY,
  IAB_UNMODERATED_UGC_CATEGORY,
} from "./../consts";

import { getFandomTaxonomyCategory } from "./getFandomTaxonomyCategory";

/**
 * @param {FandomTaxonomyCategoryKey} category - The page or site field in the fandomTaxonomy object
 * @returns {string[]} - The IAB categories for the specified category in the fandomTaxonomy object,
 * 	appended with the UGC category tag if the iab_categories field is set
 *
 * Extracts the iab_categories field from the taxonomy object based on the passed in category param.
 * Categories include 'site' and 'page', which can both be set on the fandomTaxonomy object.
 * Additionally, this function appends the UGC category tag, if iab_categories field has any values set
 * in the fandomTaxonomy object, on the specified category
 * */
export function getIABCategories(
  category: FandomTaxonomyCategoryKey,
): string[] {
  // Always send the unmoderated UGC category (1217)
  const categories = [
    IAB_UNMODERATED_UGC_CATEGORY,
    IAB_BSR_DEFAULT_LOW_RISK_CATEGORY,
  ];

  const fandomTaxonomyCategory = getFandomTaxonomyCategory(category);
  const rawValues = fandomTaxonomyCategory?.iab_categories ?? [];

  if (rawValues.length > 0) {
    categories.push(...rawValues);
  } else {
    categories.push(IAB_ENTERTAINMENT_CONTENT_CATEGORY);
  }

  // filter duplicates and empty values
  return Array.from(new Set(categories.filter(Boolean)));
}
